import * as React from "react";
import {
  TacticLoader,
  type TacticLoaderProps
} from "@cmp-src/loaders/TacticLoader/TacticLoader";

type SpinnerSize = "xs" | "sm" | "md" | "lg" | "xl";
type SpinnerVariant = "default" | "muted" | "white";

const sizeMap: Record<SpinnerSize, TacticLoaderProps["size"]> = {
  xs: "xxs",
  sm: "xs",
  md: "sm",
  lg: "sm",
  xl: "md"
};

const variantColorMap: Record<SpinnerVariant, string> = {
  default: "#49A8CE",
  muted: "#9CA3AF",
  white: "#FFFFFF"
};

export interface SpinnerProps {
  size?: SpinnerSize;
  variant?: SpinnerVariant;
  className?: string;
}

const Spinner: React.FC<SpinnerProps> = ({
  size = "md",
  variant = "default",
  className
}) => {
  return (
    <TacticLoader
      size={sizeMap[size]}
      color={variantColorMap[variant]}
      className={className}
    />
  );
};
Spinner.displayName = "Spinner";

export { Spinner };
